import { courseContextSearchParams, courseTabHref } from '@/lib/course-admin-navigation';

export const FROM_COURSE = 'course';

export function enrollmentFromCourseQuery(courseId: string, searchParams: URLSearchParams): URLSearchParams {
  const params = courseContextSearchParams(searchParams);
  params.set('from', FROM_COURSE);
  params.set('course_id', courseId);
  return params;
}

export function withSearch(path: string, params: URLSearchParams): string {
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}

export function searchSuffix(searchParams: URLSearchParams): string {
  const qs = searchParams.toString();
  return qs ? `?${qs}` : '';
}

export function enrollmentShowBack(searchParams: URLSearchParams): { to: string; label: string } {
  const courseId = searchParams.get('course_id');
  if (searchParams.get('from') === FROM_COURSE && courseId) {
    return { to: courseTabHref(courseId, 'detalle', searchParams), label: 'Volver al curso' };
  }
  return { to: '/inscripciones', label: 'Volver a matrículas' };
}

export function inscripcionesIndexBack(searchParams: URLSearchParams): { to: string; label: string } {
  const courseId = searchParams.get('course_id');
  if (searchParams.get('from') === FROM_COURSE && courseId) {
    return { to: courseTabHref(courseId, 'detalle', searchParams), label: 'Volver al curso' };
  }
  return { to: '/administracion?tab=users', label: 'Volver a Administración' };
}
